import { FaqAttributes } from "../attributes/faq-attributes";

class Faq {
  id?: number;
  question_fr: string;
  question_en: string;
  response_fr: string;
  response_en: string;

  constructor(
    id: number,
    question_fr: string,
    question_en: string,
    response_fr: string,
    response_en: string,
  ) {
    this.id = id;
    this.question_fr = question_fr;
    this.question_en = question_en;
    this.response_fr = response_fr;
    this.response_en = response_en;
  }

  static fromJson(json: FaqAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new Faq(
      json.id,
      json.question_fr,
      json.question_en,
      json.response_fr,
      json.response_en,
    );
  }
}

export default Faq;
